import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useReceivement } from '../../../../../hooks/useReceivement'
import { insertBatchsNotReceived } from '../../../../../services/receivement/divergenceService'
import { ConfirmationButton } from '../Components/ConfirmationButton'
import { NegationButton } from '../Components/NegationButton'
import { FormAddNotFoundBatchKg } from '../FormAddNotFoundBatchKg'
import { FormAddNotFoundBatch } from '../FormAddNotFoundBatch'
import ModalConfirm from '../ModalConfirm'
import { ModalResolveDivergence } from '../ModalResolveDivergence'
import TableAddNotFoundBatch from '../TableAddBatch'
import { productDivergenceBatchStore } from './services/productDivergenceBatchStore'
import * as S from './ModalAddNotFoundBatch.styles'

const ModalAddNotFoundBatch = ({
  show,
  action,
  batchId,
  productDivergenceId,
  productDescription,
  updateTable,
  isKg,
  deliveryDaysMinExpirationDate
}) => {
  const [addNewBatch, setAddNewBatch] = useState(false)
  const [batchAdded, setBatchAdded] = useState([])
  const [finishBatch, setFinishBatch] = useState(false)
  const { supervisorBadge } = useReceivement({ validateSupervisor: true })
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (productDivergenceId) {
      const batchesAdded = productDivergenceBatchStore.get(
        productDivergenceId,
        batchId
      )

      setBatchAdded(batchesAdded)
    }
  }, [productDivergenceId, batchId])

  return (
    <>
      <ModalResolveDivergence
        show={show}
        title={`Adicionar Lote`}
        action={() => {
          action()
          setAddNewBatch(false)
        }}
      >
        <S.ModalContent>
          {addNewBatch ? (
            <>
              {isKg ?
              <FormAddNotFoundBatchKg
                onSuccess={(data) => {
                  setAddNewBatch(false)
                  setBatchAdded((prevState) => {
                    const newState = [...prevState, data]
                    productDivergenceBatchStore.set(
                      productDivergenceId,
                      batchId,
                      newState
                    )

                    return newState
                  })
                }}
                onCancel={() => {
                  setAddNewBatch(false)
                }}
                deliveryDaysMinExpirationDate={deliveryDaysMinExpirationDate}
              />
              :
              <FormAddNotFoundBatch
                onSuccess={(data) => {
                  setAddNewBatch(false)
                  setBatchAdded((prevState) => {
                    const newState = [...prevState, data]
                    productDivergenceBatchStore.set(
                      productDivergenceId,
                      batchId,
                      newState
                    )
                    return newState
                  })
                }}
                onCancel={() => {
                  setAddNewBatch(false)
                }}
                deliveryDaysMinExpirationDate={deliveryDaysMinExpirationDate}
              />}
            </>
          ) : (
            <>
              <TableAddNotFoundBatch
                tableData={batchAdded}
                handleDeleteRow={(row) => {
                  setBatchAdded((prevState) => {
                    const newState = [
                      ...prevState.filter((batch) => batch != row)
                    ]
                    if (newState.lenght === 0) {
                      productDivergenceBatchStore.remove(
                        productDivergenceId,
                        batchId
                      )
                    } else {
                      productDivergenceBatchStore.set(
                        productDivergenceId,
                        batchId,
                        newState
                      )
                    }
                    return newState
                  })
                }}
              />

              <S.ContainerButton>
                <ConfirmationButton
                  title="Novo Lote"
                  onClick={() => {
                    setAddNewBatch(true)
                  }}
                />
                <NegationButton
                  title="Salvar Lotes Localizados"
                  onClick={() => {
                    setFinishBatch(true)
                  }}
                  disabled={batchAdded.length === 0 || submitting}
                />
              </S.ContainerButton>
            </>
          )}
        </S.ModalContent>
      </ModalResolveDivergence>
      <ModalConfirm
        show={finishBatch}
        alertText={
          <p>
            Finalizando a inserção de lotes previamente não encontrados:{' '}
            <b>{productDescription}</b>
          </p>
        }
        noteText={
          'Não será possível adicionar mais lotes deste produto após a confirmação'
        }
        title={'Confirmação de lotes localizados'}
        onConfirm={() => {
          setSubmitting(true)
          insertBatchsNotReceived({
            batchId,
            productDivergenceId,
            batchesNotReceived: batchAdded,
            badge: supervisorBadge
          })
            .then(() => {
              toast.success('Lotes incluidos com sucesso!')
              updateTable()
              productDivergenceBatchStore.remove(productDivergenceId, batchId)
              setFinishBatch(false)
              setAddNewBatch(false)
              action()
            })
            .catch((err) => {
              console.error(
                'Não foi possível adicionar os lotes NÃO RECEBIDOS',
                err
              )
              toast.error('Não foi possível adicionar os lotes NÃO RECEBIDOS')
            })
            .finally(() => setSubmitting(false))
        }}
        disabled={submitting}
        action={() => setFinishBatch(false)}
      />
    </>
  )
}

export default ModalAddNotFoundBatch
